/* ED 2026-10-23: Danish public holidays (helligdage) + days the warehouse is closed, for dispatch countdowns.
   Easter via the anonymous Gregorian (Meeus/Butcher) algorithm so it works every year.
   Store Bededag is abolished from 2024 and is NOT a holiday. Dates are calendar dates in Denmark. */
(function (root) {
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }
  var cache = {};
  function holidays(y) {
    if (cache[y]) return cache[y];
    var e = easter(y), D = 86400000, list = {};
    function add(ms, name) { var d = new Date(ms); list[d.getUTCMonth() + 1 + '-' + d.getUTCDate()] = name; }
    add(Date.UTC(y, 0, 1), 'Nytårsdag');
    add(e - 3 * D, 'Skærtorsdag');
    add(e - 2 * D, 'Langfredag');
    add(e, 'Påskedag');
    add(e + D, '2. Påskedag');
    add(e + 39 * D, 'Kristi Himmelfartsdag');
    add(e + 49 * D, 'Pinsedag');
    add(e + 50 * D, '2. Pinsedag');
    add(Date.UTC(y, 5, 5), 'Grundlovsdag');
    add(Date.UTC(y, 11, 24), 'Juleaften');
    add(Date.UTC(y, 11, 25), 'Juledag');
    add(Date.UTC(y, 11, 26), '2. Juledag');
    add(Date.UTC(y, 11, 31), 'Nytårsaften');
    return (cache[y] = list);
  }
  function edDkHoliday(y, m, d) { return holidays(y)[m + '-' + d] || null; }
  function edDkWorkingDay(y, m, d) {
    var wd = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
    return wd !== 0 && wd !== 6 && !edDkHoliday(y, m, d);
  }
  root.edDkHoliday = edDkHoliday;
  root.edDkWorkingDay = edDkWorkingDay;
  root.edDkEaster = easter;
  if (typeof module !== 'undefined' && module.exports) module.exports = { edDkHoliday: edDkHoliday, edDkWorkingDay: edDkWorkingDay, edDkEaster: easter };
})(typeof window !== 'undefined' ? window : this);
